import React, { useState } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { ButtonDropdown, Modal, Button } from "@bitcine/cs-theme"
import { canModifyProjects } from "@src/helpers/authorization"
import { initializeHttpUpload } from "@api/transfer/http/upload"
import { push } from "connected-react-router"
import {
  saveScreener
} from "@api/project/files/screeners/"
import "../styles.scss"
import CustomFieldsModal from "./custom_fields_modal"

const DropdownOptions = ({
  screener,
  canModify,
  push,
  saveScreener,
  options = [],
  initializeHttpUpload,
  updateThumbnail = null,
  onThumbnailUploaded = () => {},
  hoverOnly = false
}) => {
  const [editingTitle, setEditingTitle] = useState(false)
  const [newName, setNewName] = useState("")
  const [showCustomFieldsModal, setShowCustomFieldsModal] = useState(false)
  const [fileRef, setFileRef] = useState(null)
  const uploadThumbnail = (file) => {
    initializeHttpUpload(
      file,
      {
        project_id: screener.project_id,
        screener_id: screener._id
      },
      () => {
        onThumbnailUploaded()
        if (typeof updateThumbnail === "function") {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = () => updateThumbnail ? updateThumbnail(reader.result) : null
        }
      }
    )
  }
  return (
    <div onClick={e => e.stopPropagation() && e.preventDefault()}>
      <input
        type='file'
        accept='image/*'
        style={{ display: "none" }}
        ref={ref => setFileRef(ref)}
        onChange={e => {
        const file = e.target.files[0]
        if (file) {
          uploadThumbnail(file)
        }
      }}/>
      <ButtonDropdown
        button={{
          className: "link material-icons",
          menu: true,
          text: hoverOnly ? <span className={"option"}>more_vert</span> : "more_vert",
        }}
        dropdown={{
          clickCloses: true,
          content: [
            {
              text: "View screener",
              icon: "ondemand_video",
              onClick: () => push(`/projects/${screener.project_id}/files/preview-link/${screener._id}`),
              show: true
            },
            {
              text: "Update thumbnail",
              icon: "image",
              onClick: () => fileRef && fileRef.click(),
              show: canModify
            },
            {
              text: "Rename",
              icon: "edit",
              onClick: () => setEditingTitle(true),
              show: canModify
            },
            {
              text: "Edit Custom Fields",
              icon: 'list',
              onClick: () => setShowCustomFieldsModal(true),
              show: canModify
            },
            ...options
          ].filter(opt => opt.show)
        }}/>
        {editingTitle && (
          <Modal open onClose={() => setEditingTitle(false)} title='Edit Screener Name'>
            <p>Enter the new name for your screener.</p>
            <input
              className='cs-input col-12'
              value={newName}
              autoFocus
              onChange={({ target: { value } }) => setNewName(value)}/>
            <div className='flex justify-end mt2'>
              <Button
                onClick={() => {
                  if (newName !== screener.name) {
                    saveScreener(screener.project_id, screener._id, "name", newName)
                  }
                  setEditingTitle(false)
                }}>
                Save Name
              </Button>
            </div>
          </Modal>
        )}
        {showCustomFieldsModal && <CustomFieldsModal screener={screener} onClose={() => setShowCustomFieldsModal(false)}/>}
    </div>
  )
}

DropdownOptions.propTypes = {
  screener: PropTypes.object.isRequired,
  canModify: PropTypes.bool.isRequired,
  push: PropTypes.func.isRequired,
  saveScreener: PropTypes.func.isRequired,
  updateThumbnail: PropTypes.func,
  initializeHttpUpload: PropTypes.func.isRequired,
}

const mapStateToProps = (state) => ({
  canModify: canModifyProjects(state.user.auth)
})

const mapDispatchToProps = dispatch => ({
  push: bindActionCreators(push, dispatch),
  saveScreener: bindActionCreators(saveScreener, dispatch),
  initializeHttpUpload: bindActionCreators(initializeHttpUpload, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(DropdownOptions)
